import React, { Suspense } from 'react';
import LoadingSpinner from './LoadingSpinner';

interface Props {
   children: React.ReactNode;
}

const SuspenseWithLoader = ({ children }: Props) => {
   return <Suspense fallback={<SuspenseLoader />}>{children}</Suspense>;
};

export const SuspenseLoader = () => {
   return (
      <div className="flex items-center justify-center h-screen">
         <div className="animate-pulse flex flex-col items-center">
            <div className="flex items-center mt-4 gap-4">
               <LoadingSpinner />
               <span>Loading...</span>
            </div>
         </div>
      </div>
   );
};

export default SuspenseWithLoader;
